module.exports = __webpack_public_path__ + "static/media/StaticMt.0adddb39.svg";